import React from 'react'

const Title = (props) => {
  return (
    <div className="titleContainer">
      <p className="engTitle">{props.engTitle}</p>
      <div className="rhombus"></div>
      <p className="subTitle">{props.subTitle}</p>
    </div>
  )
}

export default Title
